<div class="p-3 border-start bg-light shadow-sm h-100" [ngClass]="'border-4 border-' + borderColor">
  <div class="d-flex align-items-start gap-3">
    <i class="bi fs-2" [ngClass]="icon + ' text-' + iconColor"></i>
    <div>
      <h6 class="mb-1 text-muted">{{ label }}</h6>
      <h5 class="mb-0">₹{{ amount }}</h5>
      <small class="text-muted">{{ count }} Requests</small>
    </div>
  </div>
</div>
